// ** React Imports
import { useMemo } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Hooks
import useQuery from "hooks/useQuery";

// ** Custom Filters
import { compute as filterLookingAgeCompute } from "hooks/filters/useFilterAgeSlider";

// ** Utils & Helpers
import { AGE_RANGE } from "helpers/constants";

// #####################################################

const useLookingAgeFilterData = () => {
	const { t } = useTranslation(["common", "filtersAndSelectors"]);

	const language = useSelector((state) => state.globalCommon.language);

	const query = useQuery();

	const { who_search_age: searchAgeUrl } = query || {};

	// ** Filtr - Którzy szukają w wieku
	const lookingAgeFilterData = useMemo(() => {
		const lookingAgeFilterValue =
			filterLookingAgeCompute.urlToApiParam(searchAgeUrl);
		return searchAgeUrl
			? {
					label: t("filtersAndSelectors:lookingAge"),
					selected:
						lookingAgeFilterValue === AGE_RANGE.MAX
							? lookingAgeFilterValue +
							  "+" +
							  " " +
							  t("common:years")
							: lookingAgeFilterValue + " " + t("common:years"),
			  }
			: null;
	}, [searchAgeUrl, language]);

	// #####################################################

	return lookingAgeFilterData;
};

// #####################################################

export default useLookingAgeFilterData;

// #####################################################
